/* import __COLOCATED_TEMPLATE__ from './lsg-nav-with-counts.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { throttle } from '@ember/runloop';
import clsx from 'clsx';

const CLASS_NAME = 'LSG-c-nav-with-counts';

/**
 * Component which displays a navigational tab list. Can also render arbitrary code beside the tab
 * list which is passed in via {{yield}}.
 *
 * @example [{
 *   title: string
 *   count: number
 *   isActive: function
 *   isHighlight: function
 *   materialIcon: string
 *   isAdminSection: bool
 * }]
 */
class LsgNavWithCountsComponent extends Component {
  #scrollWrapperDestructor = null;

  @tracked
  showScrollHintLeft = false;

  @tracked
  showScrollHintRight = false;

  get CLASS_NAME() {
    return CLASS_NAME;
  }

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  @action
  didInsertScrollWrapper(element) {
    const updateScrollHints = () => {
      if (this.isDestroying) {
        return;
      }

      const { offsetWidth, scrollWidth, scrollLeft } = element;

      const showScrollLeft = scrollLeft > 0;
      const showScrollRight = offsetWidth + scrollLeft < scrollWidth - 1;

      if (this.showScrollHintLeft !== showScrollLeft) {
        this.showScrollHintLeft = showScrollLeft;
      }

      if (this.showScrollHintRight !== showScrollRight) {
        this.showScrollHintRight = showScrollRight;
      }
    };

    const callback = () => {
      throttle(this, updateScrollHints, 100);
    };

    const observer = new ResizeObserver(() => {
      callback();
    });

    observer.observe(element);
    element.addEventListener('scroll', callback, { passive: true });

    this.#scrollWrapperDestructor = () => {
      observer.disconnect();
      element.removeEventListener('scroll', callback);
    };
  }

  @action
  willDestroyScrollWrapper() {
    if (this.#scrollWrapperDestructor) {
      this.#scrollWrapperDestructor();
      this.#scrollWrapperDestructor = null;
    }
  }
}

export default LsgNavWithCountsComponent;
